<template>
	<div class="wrapper">
		<headerTag />
		<div class="zxDetail">
			<p class="zxDetail-title">{{nTitle}}</p>
			<p class="zxDetail-top">
				<span>来源：<i>{{nFrom}}</i></span>
				<span>{{publicTime}}</span>
				<span>
					<img src="../../assets/images/user/view.png" alt=""/>
					<i>{{nCount}}</i>
				</span>
			</p>
			<div class="zxDetail-txt" v-html="nContent"></div>
		</div>
		
	</div>

</template>

<script>
   
    import "../../assets/css/user.scss"
    import headerTag from '@/components/headerTag/headerTag.vue'
    
    export default {
    	name: 'zxDetail',
    	props: {
        
    	},
		data(){
		  return {
		    nid:'',
			nTitle:'',
			nFrom:'',
			publicTime:'',
			nCount:'',
			nContent:'',
		  }
		},
    	components: {
    		headerTag,
    	},
		methods: {
				getNewsDetail(){
					this.axios({
					 	method: 'POST',
					 	url:'/news/getNewsDetail',
						params:{
							nid:this.nid
					 	},
					}).then((res)=>{
							if(res.data.code==1000){
					 			let data = res.data.data.news;
								this.nTitle=data.nTitle;
								this.nFrom=data.nFrom;
								this.publicTime=data.publicTime;
								this.nCount=data.nCount;
								this.nContent=data.nContent;
					 		}
					}).catch((err)=>{
					 	this.$message.error({message: '获取数据失败'});
					})
				},
		},
		created(){
			this.nid = this.$route.params.id;
			this.getNewsDetail()
		},
    }
</script>


